<template>
  <section>
    <b-overlay :show="loading" rounded="sm">
      <div v-if="!verifying">
        <b-button  variant="dark"
          v-on:click="loginSubmit"          
        >
          {{ $t("START_IDENTIFICATION") }}
        </b-button>
      </div>
      <div class="text-center" v-if="verifying">
        <div class="caption-title">{{ $t("EMAIL_OTP") }}</div>
        
      <b-form-group 
          id="input-code"
          :label="$t('EMAIL_OTP')"
          label-for="code"
        >
        <b-form-input trim
          class="mt-2 text-center form-control"
          v-model="code"
          type="tel"
          name="code"
          id="code"
          required
          v-on:keyup.enter="authenticateIdentifier"
          :placeholder="$t('CODE')"
        ></b-form-input>
      </b-form-group>
        <div class="mt-4">
          <b-button  variant="dark"  v-on:click="authenticateIdentifier"
            :disabled="disableVerify">
            {{ $t("VERIFY_BTN") }}
          </b-button>

        </div>
        <div class="mt-2">
          <button
            v-on:click="cancelSubmit"
            class="mt-2 btn btn-secondary"
          >
            {{ $t("CANCEL") }}
          </button>
        </div>
      </div>
    </b-overlay>
  </section>
</template>
<script>
export default {
  props: ["link_uuid"],
  data() {
    return {
      verifying: false,
      loading: true,
      statusMessage: "",
      code: "",
      auth_uuid: "",
      hintMessage: "",
      errorMessage: "",
    };
  },
  methods: {
    cancelSubmit: function() {
      let self = this;
      clearTimeout(this.timer);
      self.loading = false;
      self.verifying = false;
      self.$emit("loading", false);
      this.$http
        .get(this.user.hostname + "/authenticate/cancel/" + this.auth_uuid)
        .then(function() {});
    },
    loginSubmit: function() {
      let self = this;
      self.loading = true;
      self.$emit("loading", true);
      this.$http
        .post(this.user.hostname + "/message/link/authenticate/", {
          link_uuid: this.link_uuid
        })
        .then(function(result) {
          self.loading = false;
          self.verifying = true;
          self.auth_uuid = result.data.auth_uuid;
          self.$emit("loading", true);
        })
        .catch(function() {
          self.$emit("loading", false);
          self.verifying = false;
          self.loading = false;
        });
    },
    authenticateIdentifier: function() {
      let self = this;
      //this.verifying = true;
      this.loading = true;
      this.$http
        .post(this.user.hostname + "/authenticate/verify", {
          auth_uuid: this.auth_uuid,
          code: this.code.trim(),
        })
        .then(function(result) {
          self.verifying = false;
          self.$emit("authenticated", result.data.token);
        })
        .catch(function() {
          self.loading = false;
          self.$emit("loading", false);
          self.loading = false;
          self.code = "";
          self.verifying = false;
        });
    },
  },
  computed: {
    disableVerify: function() {
      return this.code.length != 4;
    },
  },
  mounted: function() {
    this.loading = false;
  },
};
</script>
<style></style>
